import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
import SimpleButton from '@/components/SimpleButton.vue';
import RoundButton from '@/components/RoundButton.vue';
import RoundButtonMenu from '@/components/RoundButtonMenu.vue';
import DetailField from '@/components/DetailField.vue';
import draggable from 'vuedraggable';
import formatting from '@/formatting';
import { api } from '../api';
import { ChoiceOptionList } from '@/interfaces';
import { Getter, Mutation } from 'vuex-class';
import moment from 'moment';
import {
  commitAddNotification,
  commitRemovePersistentNotifications
} from '@/store/main/mutations';
// tslint:disable: quotemark

@Component({
  components: {
    SimpleButton,
    RoundButton,
    RoundButtonMenu,
    DetailField,
    draggable
  }
})
export default class DocumentMixin extends Mixins(PrivilegeMixin) {
  public api = api;
  public formatting = formatting;

  public originalUnitPriceVersion = 1;
  public quantityVersion = 1;
  public estimatedQuantityVersion = 1;
  public quantityCorrectionVersion = 1;
  public unitPriceVersion = 1;

  public vatrates: any;
  public unittypes: any;

  public labelCols = '2';
  public inputCols = '10';

  public orderDocTypeNames = {
    1: 'quotes',
    2: 'orders',
    4: 'invoices',
    5: 'credit_notes',
    6: 'templates'
  };

  public orderDocTypeIds = {
    quotes: 1,
    orders: 2,
    invoices: 4,
    credit_notes: 5,
    templates: 6
  };

  public privs = {
    quotes: 'pr_quotes',
    orders: 'pr_orders',
    invoices: 'pr_invoices',
    credit_notes: 'pr_credit_notes',
    templates: 'pr_quotes'
  };

  public overviewTitles = {
    quotes: 'Offertes',
    orders: 'Werkbonnen',
    invoices: 'Facturen',
    credit_notes: "Kredietnota's",
    templates: 'Templates'
  };

  public detailTitles = {
    quotes: 'Offerte',
    orders: 'Werkbon',
    invoices: 'Factuur',
    credit_notes: 'Kredietnota',
    templates: 'Template'
  };

  public deleteTitles = {
    quotes: 'deze offerte',
    orders: 'deze werkbon',
    invoices: 'dit factuur',
    credit_notes: 'deze kredietnota',
    templates: 'deze template'
  };

  public urls = {
    purchase_quotes: '/purchase/quotes',
    purchase_credit_notes: '/purchase/credit_notes',
    sale_quotes: '/sale/quotes',
    sale_orders: '/sale/orders',
    sale_invoices: '/sale/invoices',
    sale_credit_notes: '/sale/credit_notes',
    sale_templates: '/sale/templates'
  };

  public filterNames = {
    sale_quotes: 'sale_quotes',
    orders: 'orders',
    invoices: 'invoices',
    credit_notes: 'credit_notes',
    templates: 'templates'
  };

  public termDefaults = {
    quotes:
      'Materialen zijn dagprijzen en kunnen aanleiding geven tot prijsaanpassingen.',
    orders: null,
    invoices: null,
    credit_notes: null,
    templates: null
  };

  public warrantyDefaults = {
    quotes:
      '10 jaar op de waterdichtheid op het dak, enkel indien lood is ingemetst.',
    orders: null,
    invoices: null,
    credit_notes: null,
    templates: null
  };

  public transitions = {
    sale_quotes: [
      {
        url: this.urls.sale_orders,
        orderDocTypeId: this.orderDocTypeIds.orders,
        title: 'Maak een werkbon',
        object: {
          info: '',
          terms: '',
          endnotes: '',
          creationdate: moment().format('YYYY-MM-DD')
        }
      },
      {
        url: this.urls.sale_invoices,
        orderDocTypeId: this.orderDocTypeIds.invoices,
        title: 'Maak een factuur',
        object: {
          info:
            'Uitgevoerde dakwerken volgens offerte {docnr} en detail in bijlage.',
          terms: '',
          endnotes: '',
          due_date: moment()
            .add(15, 'days')
            .format('YYYY-MM-DD'),
          creationdate: moment().format('YYYY-MM-DD')
        }
      }
    ],
    sale_templates: [
      {
        url: this.urls.sale_quotes,
        orderDocTypeId: this.orderDocTypeIds.quotes,
        title: 'Maak een offerte',
        object: {
          info: '',
          terms: this.termDefaults.quotes,
          warranty_remarks: this.warrantyDefaults.quotes,
          due_date: moment()
            .add(4, 'weeks')
            .format('YYYY-MM-DD')
        }
      }
    ]
  };

  public projectActions = [
    {
      url: this.urls.sale_quotes,
      title: 'Maak een offerte'
    },
    {
      url: this.urls.sale_orders,
      title: 'Maak een werkbon'
    },
    {
      url: this.urls.sale_invoices,
      title: 'Maak een factuur'
    }
  ];

  public emailActions = {
    sale_quotes: [
      {
        title: 'Verstuur offerte'
      }
    ],
    sale_invoices: [
      // {title: 'Verstuur factuur'}
    ]
  };

  public manualActions = {
    sale_quotes: [
      {
        title: 'Markeer als verstuurd',
        postAction: 'manualsend'
      },
      {
        title: 'Markeer als goedgekeurd',
        postAction: 'mark_approved'
      }
    ],
    sale_invoices: [
      {
        title: 'Markeer als verstuurd',
        postAction: 'manualsend'
      },
      {
        title: 'Markeer als betaald',
        postAction: 'mark_paid'
      }
    ]
  };

  @Getter('getCachedChoice')
  public getCachedChoice!: (name: string) => ChoiceOptionList;

  @Mutation('setCachedChoice')
  public setCachedChoice;

  @Getter('getSelectedItem')
  public getSelectedItem;

  @Mutation('setSelectedItem')
  public setSelectedItem;

  public defaultLine(orderDoc) {
    return {
      description: 'Nieuw',
      quantity:
        orderDoc &&
        this.orderDocTypeNames[orderDoc.orderdoctype_id] === 'templates'
          ? 0
          : 1,
      unitPrice: undefined,
      unitType: 1,
      vatRate: 1,
      quantity_correction_percentage: 0,
      hide_from_customer: false,
      hide_quantity_from_customer: true
    };
  }

  public isQuote() {
    return this.getDocType(this.$route.path) === 'quotes';
  }

  public isOrder() {
    return this.getDocType(this.$route.path) === 'orders';
  }

  public isInvoice() {
    return this.getDocType(this.$route.path) === 'invoices';
  }

  public isTemplate() {
    return this.getDocType(this.$route.path) === 'templates';
  }

  public allowRevision() {
    return this.isQuote() || this.isOrder();
  }

  public getItem(id, rec) {
    const recordId: number = Number(id.substring(1));
    let item;
    if (id.charAt(0) === 'g' && rec.groups) {
      item = rec.groups.find(g => g.group_id === recordId);
    } else if (id.charAt(0) === 'l' && rec.lines) {
      item = rec.lines.find(l => l.id === recordId);
    }
    return item;
  }

  public getDocType(path: string) {
    console.assert(path.startsWith('/'), {
      path,
      errorMsg: 'Path does not start with /'
    });
    return path.split('/')[2];
  }

  public getBookType(path: string) {
    console.assert(path.startsWith('/'), {
      path,
      errorMsg: 'Path does not start with /'
    });
    return path.split('/')[1];
  }

  public getBookDocType(path: string) {
    console.assert(path.startsWith('/'), {
      path,
      errorMsg: 'Path does not start with /'
    });
    const parts = path.split('/');
    return parts[1] + '_' + parts[2];
  }

  public getURL(path: string, idStr = '') {
    const url = this.urls[this.getBookDocType(path)];
    if (idStr) {
      return url + '/' + idStr;
    } else {
      return url;
    }
  }

  public getFixedFilter(context) {
    return {
      orderdoctype_id: this.orderDocTypeIds[
        this.getDocType(context.$route.path)
      ],
      book_target: this.getBookType(context.$route.path)
    };
  }

  public getRelationColumn(path: string) {
    if (this.getBookType(path) === 'sale') {
      return {
        text: 'Klant',
        value: 'customer_name',
        link: '/sale/customers/{customer_id}',
        width: '20%'
      };
    } else {
      return {
        text: 'Leverancier',
        value: 'supplier_name',
        link: '/purchase/suppliers/{supplier_id}',
        width: '20%'
      };
    }
  }

  public getFilterName(context) {
    return this.urls[this.getBookDocType(context.$route.path)];
  }

  public getTransition(path) {
    return this.transitions[this.getBookDocType(path)];
  }

  public getEmailActions(path) {
    return this.emailActions[this.getBookDocType(path)];
  }

  public getManualActions(path) {
    return this.manualActions[this.getBookDocType(path)];
  }

  public openDocumentForItem(item, newTab = true) {
    if (item) {
      const bookDocType =
        'sale' + '_' + this.orderDocTypeNames[item.orderdoctype_id];
      const path = this.getURL(this.urls[bookDocType], String(item.id));
      const url = this.$router.resolve({
        path
      });
      if (newTab) {
        window.open(url.href, '_blank');
      } else {
        this.$router.push(path);
      }
    }
  }

  public parseId(id) {
    return Number(id.substring(1));
  }

  public newLine(id, parentGroupId, index, orderDoc) {
    return {
      id,
      orderdoc_id: orderDoc.id,
      parent_group_id: parentGroupId,
      index,
      product_id: null,
      description: this.defaultLine(orderDoc).description,
      hide_from_customer: this.defaultLine(orderDoc).hide_from_customer,
      hide_quantity_from_customer: this.defaultLine(orderDoc)
        .hide_quantity_from_customer,
      comments: '',
      quantity: this.defaultLine(orderDoc).quantity,
      estimated_quantity: this.defaultLine(orderDoc).quantity,
      is_custom_description: false,
      unit_price: this.defaultLine(orderDoc).unitPrice,
      original_unit_price: this.defaultLine(orderDoc).unitPrice,
      unittype_id: this.defaultLine(orderDoc).unitType,
      price_correction_amount: 0,
      price_correction_percentage: 0,
      vatrate_id: this.defaultLine(orderDoc).vatRate,
      show_quantity: true,
      amount_exclusive: 0,
      amount_inclusive: 0,
      quantity_correction_percentage: this.defaultLine(orderDoc)
        .quantity_correction_percentage
    };
  }

  public sortItems(items) {
    items.sort((a, b) => (a.index > b.index ? 1 : -1));
    items.forEach(item =>
      item.children ? this.sortItems(item.children) : null
    );
    // Index only needed to sort children
    items.forEach(item => delete item.index);
  }

  public isGroup(id) {
    return id && id.charAt(0) === 'g' && id !== 'g0';
  }

  public isLine(id) {
    return id && id.charAt(0) === 'l';
  }

  public calculateEstimatedQuantity(rec) {
    return rec.quantity_correction_percentage != null
      ? Math.round(
          (rec.quantity_correction_percentage / 100 + 1) * rec.quantity * 100
        ) / 100
      : rec.quantity;
  }

  public calculateQuantityCorrection(rec) {
    return (
      Math.round((rec.estimated_quantity / rec.quantity - 1) * 100 * 100) / 100
    );
  }

  public calculateUnitPrice(rec) {
    return (
      Math.round(
        (rec.estimated_quantity / rec.quantity) * rec.original_unit_price * 100
      ) / 100
    );
  }

  public async productChanged(rec, isArchitect) {
    if (rec.product_id) {
      const productResponse: any = await this.api.getRecord(
        null,
        '/products/' + rec.product_id
      );
      if (productResponse) {
        const product = productResponse.data;
        rec.description = product.description;
        rec.unittype_id = product.unittype_id;
        if (isArchitect) {
          rec.original_unit_price = product.unit_price;
          this.originalUnitPriceVersion += 1;
          this.originalUnitPriceChanged(rec);
        } else {
          rec.unit_price = product.unit_price;
          this.unitPriceVersion += 1;
        }
        this.$emit('calculateAmounts');
      }
    } else {
      this.productReset(rec, isArchitect);
    }
  }

  public productReset(rec, isArchitect) {
    rec.description = this.defaultLine(rec).description;
    rec.hide_from_customer = this.defaultLine(rec).hide_from_customer;
    rec.hide_quantity_from_customer = this.defaultLine(
      rec
    ).hide_quantity_from_customer;
    rec.unit_price = this.defaultLine(rec).unitPrice;
    rec.unittype_id = this.defaultLine(rec).unitType;
    rec.vatrate_id = this.defaultLine(rec).vatRate;
    if (isArchitect) {
      rec.original_unit_price = this.defaultLine(rec).unitPrice;
      this.originalUnitPriceVersion += 1;
    }
    this.unitPriceVersion += 1;
    this.originalUnitPriceVersion += 1;
    this.$emit('calculateAmounts');
  }

  public quantityChanged(rec) {
    if (rec.quantity) {
      // Calculate estimated quantity
      rec.estimated_quantity = this.calculateEstimatedQuantity(rec);
      this.estimatedQuantityVersion += 1;
      rec.quantity_correction_percentage = this.calculateQuantityCorrection(
        rec
      );
      this.quantityCorrectionVersion += 1;
      if (rec.original_unit_price != null) {
        // Calculate scaled unit price
        rec.unit_price = this.calculateUnitPrice(rec);
        this.unitPriceVersion += 1;
        this.$emit('calculateAmounts');
      } else {
        this.$emit('calculateAmounts');
      }
    }
  }

  public quantityCorrectionChanged(rec) {
    if (rec.quantity_correction_percentage != null && rec.quantity) {
      // Calculate estimated quantity
      rec.estimated_quantity = this.calculateEstimatedQuantity(rec);
      this.estimatedQuantityVersion += 1;
      if (rec.original_unit_price != null) {
        // Calculate scaled unit price
        rec.unit_price = this.calculateUnitPrice(rec);
        this.unitPriceVersion += 1;
        this.$emit('calculateAmounts');
      }
    }
  }

  public estimatedQuantityChanged(rec) {
    if (rec.quantity && rec.estimated_quantity) {
      // Calculate correction percentage
      rec.quantity_correction_percentage = this.calculateQuantityCorrection(
        rec
      );
      this.quantityCorrectionVersion += 1;
      if (rec.original_unit_price != null) {
        // Calculate scaled unit price
        rec.unit_price = this.calculateUnitPrice(rec);
        this.unitPriceVersion += 1;
      }
      this.$emit('calculateAmounts');
    } else {
      rec.quantity_correction_percentage = 0;
      this.quantityCorrectionVersion += 1;
      this.quantityCorrectionChanged(rec);
    }
  }

  public originalUnitPriceChanged(rec) {
    if (rec.original_unit_price != null) {
      if (rec.quantity && rec.estimated_quantity) {
        // Calculate scaled unit price
        rec.unit_price = this.calculateUnitPrice(rec);
      } else {
        rec.unit_price = rec.original_unit_price;
      }
      this.unitPriceVersion += 1;
      this.$emit('calculateAmounts');
    }
  }

  public validateLines(rec) {
    let message = '';
    let valid = true;
    const architectValidation = [
      { field: 'quantity', message: 'Aantal architect' },
      { field: 'estimated_quantity', message: 'Aantal' },
      { field: 'unit_price', message: 'Gecorrigeerde eenheidsprijs' },
      {
        field: 'original_unit_price',
        message: 'Oorspronkelijke eenheidsprijs'
      },
      { field: 'unittype_id', message: 'Eenheid' }
    ];
    const regularValidation = [
      { field: 'quantity', message: 'Aantal' },
      { field: 'unit_price', message: 'Eenheidsprijs' },
      { field: 'unittype_id', message: 'Eenheid' }
    ];
    for (const line of rec.lines) {
      if (rec.is_architect) {
        // Validate architect document
        for (const val of architectValidation) {
          if (line[val.field] === undefined || line[val.field] === null) {
            valid = false;
            message +=
              val.message + ' ontbreekt voor ' + line.description + '. ';
          }
        }
      } else {
        // Validate regular document
        for (const val of regularValidation) {
          if (line[val.field] === undefined || line[val.field] === null) {
            valid = false;
            message +=
              val.message + ' ontbreekt voor ' + line.description + '. ';
          }
        }
      }
    }
    commitRemovePersistentNotifications(this.$store);
    if (!valid) {
      commitAddNotification(this.$store, {
        content: message,
        color: 'error',
        persistent: true
      });
    }
    return valid;
  }
}
